import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { FilterButton, IOption } from "@digital-services/ui";
import { usePaginationContext } from "@ds-cps/ui";

import { ResourceMetadataKeys } from "@resource/models";
import { useGetDistinctResourcesMetadataValues } from "@resource/services/use-get-distinct-resources-metadata-values";

import { useResourcesContext } from "../context/useResourcesContext";

export const ProductFamilyNameFilter = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "resources"
  });

  const { productFamilyNameFilter, setProductFamilyNameFilter } =
    useResourcesContext();

  const { pageIndex, setPageIndex } = usePaginationContext();

  const { data, isLoading } = useGetDistinctResourcesMetadataValues(
    ResourceMetadataKeys.ProductFamilyName
  );

  const [options, setOptions] = useState<IOption[]>([]);

  useEffect(() => {
    const emptyItem = { value: "-", label: "-" };

    if (data && data.values.length > 0) {
      const dataItems = data?.values.map(element => {
        return {
          value: element,
          label: element
        };
      }) as IOption[];

      setOptions([emptyItem, ...dataItems!]);
    }
  }, [data]);

  return (
    <FilterButton
      data-testid="filter-by-product-family-name"
      singleFilter={true}
      isLoading={isLoading}
      options={options?.length ? options : []}
      selected={productFamilyNameFilter ? [productFamilyNameFilter] : []}
      onSelect={(options: IOption[]) => {
        if (options?.length) {
          setProductFamilyNameFilter(options[0]);
        } else {
          setProductFamilyNameFilter(null);
        }

        // This is to reset pagination when filtering by device type or state happens
        if (pageIndex !== 0) {
          setPageIndex(0);
        }
      }}
    >
      {productFamilyNameFilter?.label || t("filters.byProductFamilyName")}
    </FilterButton>
  );
};
